import { Controller } from "@hotwired/stimulus"

// Submits the parent form when the language selector changes.
export default class extends Controller {
  change() {
    this.element.closest('form').submit()
  }
}
